module.exports = ".card .card-header .card-header-right .card-option {\n  width: 140px;\n  -webkit-transition: unset;\n  transition: unset; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/card/card.component.scss
// module id = ./src/app/modules/card/card.component.scss
// module chunks = main